import axios from 'axios';
import { useAuthStore } from '@/store/auth.store';
import { queryClient } from './query-client';

const CLINICA_BLOCKED_CODES = ['CLINICA_ARCHIVADA', 'CLINICA_ARCHIVADA_SOLO_LECTURA', 'CLINICA_PURGADA_TOTAL'];

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL ?? '',
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true, // send httpOnly cookie on every request
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      queryClient.clear();
      useAuthStore.getState().logout();
      window.location.href = '/login';
      return Promise.reject(err);
    }

    const code = err.response?.data?.message?.code ?? err.response?.data?.code;
    if (err.response?.status === 403 && CLINICA_BLOCKED_CODES.includes(code)) {
      window.location.href = `/clinica-archivada?code=${code}`;
      return Promise.reject(err);
    }

    return Promise.reject(err);
  },
);

export default api;
